import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

interface Interview {
  cohort_vision: string;
  company_cover_image: string;
  company_dark_background_logo: string;
  company_light_background_logo: string;
  created_at: string;
  created_by: string;
  guid: string;
  name: string;
  number_of_invited_applicants: number;
  uid: string;
  updated_at: string;
  videos: string[];
  is_default_branding: boolean;
  is_practice: boolean;
}

const useGetAssessmentDetails = (interviewUid: string) => {
  const { data, isLoading, isFetching, refetch } = useQuery<Interview, Error>(
    ['getAssessmentDetails', interviewUid],
    async () =>
      fetchWithCsrfToken<Interview>(
        `${PrependUrl.ASYNC}/assessment/get_details`,
        'POST',
        { interview: interviewUid }
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
    refetch,
    isFetching,
  };
};

export default useGetAssessmentDetails;
